"use client";

import React from "react";
import { sendGAEvent, sendGTMEvent } from "@next/third-parties/google";

export function BookingWidget({
  title,
  subtitle,
  dict = {},
}: {
  title?: string;
  subtitle?: string;
  dict?: Record<string, string>;
}) {
  const finalTitle = title || dict["booking.defaultTitle"];
  const finalSubtitle = subtitle || dict["booking.defaultSubtitle"];
  const handleBookingClick = () => {
    // Send GA Event (Google Analytics 4)
    sendGAEvent("event", "booking_initiated", {
      value: "calendar_click",
    });

    // Send GTM Event (Google Tag Manager)
    sendGTMEvent({
      event: "booking_click",
      button_name: "book_calendar",
    });

    // You can also add Google Ads Conversion Tracking if needed, e.g.:
    if (typeof window !== "undefined" && (window as any).gtag) {
      (window as any).gtag("event", "conversion", {
        send_to: "AW-CONVERSION_ID/CONVERSION_LABEL", // Replace with your Ads conversion ID/Label
      });
    }

    console.log("Analytics: Booking link clicked (Events sent to GA/GTM)");
  };

  return (
    <div className="rounded-xl bg-muted/50 p-6 sm:p-8 border border-border backdrop-blur-sm shadow-xl">
      <div className="mb-6">
        <h3 className="text-2xl font-bold tracking-tight text-foreground">
          {finalTitle}
        </h3>
        <p className="mt-2 text-sm text-muted-foreground">{finalSubtitle}</p>
      </div>

      <div className="space-y-6">
        <p className="text-muted-foreground text-sm leading-relaxed">
          {dict["booking.text"]}
        </p>
        <a
          href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0hXX6_sa0o2fAuNhs-Hli7pN2Z0UfJt7_7Y-AIY5v6VNw9JYvNgJShg0SpavP4x5-h4GLZY21J"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleBookingClick}
          className="mt-4 block w-full rounded-md bg-foreground px-3.5 py-3 text-center text-sm font-bold text-background shadow-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-foreground transition-all"
        >
          {dict["booking.btn"]}
        </a>
      </div>
    </div>
  );
}
